
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_1arpp_94",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_1arpp_1",
  "root": "awsui_root_mx3cw_1arpp_120",
  "hidden": "awsui_hidden_mx3cw_1arpp_134",
  "body": "awsui_body_mx3cw_1arpp_157",
  "header": "awsui_header_mx3cw_1arpp_163",
  "action": "awsui_action_mx3cw_1arpp_167",
  "action-button": "awsui_action-button_mx3cw_1arpp_172",
  "text": "awsui_text_mx3cw_1arpp_176",
  "icon": "awsui_icon_mx3cw_1arpp_180",
  "message": "awsui_message_mx3cw_1arpp_183",
  "breakpoint-default": "awsui_breakpoint-default_mx3cw_1arpp_191",
  "content": "awsui_content_mx3cw_1arpp_205",
  "dismiss": "awsui_dismiss_mx3cw_1arpp_209",
  "dismiss-button": "awsui_dismiss-button_mx3cw_1arpp_215",
  "type-error": "awsui_type-error_mx3cw_1arpp_223",
  "type-warning": "awsui_type-warning_mx3cw_1arpp_231",
  "type-success": "awsui_type-success_mx3cw_1arpp_239",
  "type-info": "awsui_type-info_mx3cw_1arpp_247"
};
  